// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-icon {\n  margin-right: 16px;\n}\n\nion-list {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\nion-label {\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  line-height: 46px !important;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
